import {
  GetThemeData
} from "@/api/Theme.js";



const state = {
  sitestyle: localStorage.getItem("theme") || ''
}

const mutations = {
  mSetGetThemeData: (state) => {
    GetThemeData().then((res) => {
      if (res.Code == 200) {
        if (res.Data.ThemeName != "") {
          state.sitestyle = res.Data.ThemeName;
        }
      }
    });
  },
  mSetsitestyle: (state, value) => {
    state.sitestyle = value;
    localStorage.setItem("theme", value)
  },
}

const actions = {
  aSetsitestyle({
    commit
  }, value) {
    commit('mSetsitestyle', value);
  },
  aSetGetThemeData({
    commit
  }) {
    commit('mSetGetThemeData');
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/theme.js